export default {
  Id: '',
  Status: '',
};
